import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-floating" }
const _hoisted_3 = { class: "form-floating mb-1" }
const _hoisted_4 = { class: "form-floating mb-1" }
const _hoisted_5 = { class: "form-floating mb-1" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = { class: "form-floating mb-1" }
const _hoisted_9 = { class: "form-floating mb-1" }
const _hoisted_10 = { class: "form-floating mb-1" }
const _hoisted_11 = { class: "form-floating mb-1" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-floating" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "form-floating" }
const _hoisted_16 = { class: "form-floating mb-4" }
const _hoisted_17 = { class: "container mt-4" }
const _hoisted_18 = { class: "row align-items-center" }
const _hoisted_19 = { class: "col-md-9 ps-0" }
const _hoisted_20 = { class: "col-md-3 d-flex justify-content-center align-items-center" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = ["disabled"]

import { ref, watch, onMounted, computed, reactive } from "vue";
import { app } from "@/guiide/ts/app";
import { AdditionalPersonalInfo } from "@/guiide/ts/additionalPersonalInfo";
import { Country } from "@/guiide/ts/country";
import Result from "@/guiide/ts/result";
import { PropertyInfo } from "@/guiide/ts/propertyInfo";
import SubSection from "../common/SubSection.vue";
import DynamicAdviceViewer from "../common/DynamicAdviceViewer.vue";
import Dropdown from "../common/Dropdown.vue";
import Constants from "@/guiide/ts/constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'Apply',
  props: {
    isApplying: { type: Boolean, default: false },
    adviceMessage: { type: String, default: "" }
},
  emits: ["apply"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

__expose({ validateAdditionalInfo, getAdditionalInfo });

class ApplicationInfo {
    title: string;
    firstName: string;
    middleNames: string;
    lastName: string;
    houseNumber: string;
    street: string;
    townOrCity: string;
    postCode: string;
    country: string;
    nationality: string;
    mobileCountryCode: string;
    mobile: string;
}

const additionalInfoPropertyInfo: Record<keyof ApplicationInfo, PropertyInfo> = {
  title: new PropertyInfo("title"),
  firstName: new PropertyInfo("first name"),
  middleNames: new PropertyInfo("middle names", true),
  lastName: new PropertyInfo("last name"),
  houseNumber: new PropertyInfo("house number or name"),
  street: new PropertyInfo("street"),
  townOrCity: new PropertyInfo("town or city"),
  postCode: new PropertyInfo("postcode"),
  country: new PropertyInfo("country"),
  nationality: new PropertyInfo("nationality"),
  mobileCountryCode: new PropertyInfo("mobile country code"),
  mobile: new PropertyInfo("mobile number"),
};

const alreadyInDrawdown = ref("No");
const pensionsAlreadyInDrawdownWarning = ref("");
const countries = ref<Array<Country>>(new Array<Country>());

onMounted(async () => {
    const countriesData = await app.getCountries();
    countries.value = countriesData;
});

const applicationDetail: ApplicationInfo = reactive<ApplicationInfo>({
    title: "",
    firstName: "",
    middleNames: "",
    lastName: "",
    houseNumber: "",
    street: "",
    townOrCity: "",
    postCode: "",
    country: "United Kingdom",
    nationality: "British",
    mobileCountryCode: "+44 (United Kingdom)",
    mobile: ""
});

watch(
    () => alreadyInDrawdown.value,
    (newValue: string) => {
        pensionsAlreadyInDrawdownWarning.value = newValue == "Yes"
            ? "Unfortunately we're unable to transfer pensions that are already in drawdown. Please ensure any pensions already in drawdown are not selected in your transfer list above."
            : "";
    }
)

const countriesDropdownData = computed<Array<string>>(() => {
    return countries?.value?.map(c => c.name) ?? new Array<string>();
});

const nationalityDropdownData = computed<Array<string>>(() => {
    return countries?.value?.map(c => c.nationality) ?? new Array<string>();
})

const mobileCountryDropdownData = computed<Array<string>>(() => {
    return countries?.value?.map(c => `${c.dialingCode} (${c.name})`) ?? new Array<string>();
})

async function onApplyClicked() {
    await emit('apply');
}

function validateAdditionalInfo(): Result {
    for (const key in applicationDetail) {
        if (Object.prototype.hasOwnProperty.call(applicationDetail, key)) {
            const value = applicationDetail[key as keyof ApplicationInfo];
            const propertyInfo = additionalInfoPropertyInfo[key as keyof ApplicationInfo];

            if (value === "" && !propertyInfo.optional) {
                return new Result(false, `Please tell us your ${propertyInfo.referenceName}.`);
            }
        }
    }

    return new Result(true);
}

function getAdditionalInfo(): AdditionalPersonalInfo {
    const nationalityCountry = countries.value.find(c => c.nationality == applicationDetail.nationality);
    const addressCountry = countries.value.find(c => c.name == applicationDetail.country);
    const mobileCountryCodeElements = applicationDetail.mobileCountryCode.split(' ');
    const mobileCountryDialingCode = mobileCountryCodeElements[0];
    const mobileCountry = countries.value.find(c => c.dialingCode == mobileCountryDialingCode);

    return {
        title: applicationDetail.title,
        firstName: applicationDetail.firstName,
        middleNames: applicationDetail.middleNames,
        lastName: applicationDetail.lastName,
        nationality: nationalityCountry.isoCode,
        address: {
            houseNumber: applicationDetail.houseNumber,
            street: applicationDetail.street,
            townOrCity: applicationDetail.townOrCity,
            postCode: applicationDetail.postCode,
            country: addressCountry.isoCode
        },
        mobileCountryCode: mobileCountry.isoCode,
        mobile: applicationDetail.mobile
    }
}

function onInfoDoubleClick() {
    Object.assign(applicationDetail, {
        title: "Mr",
        firstName: "John",
        lastName: "Walker",
        houseNumber: "45",
        street: "Hillview Road",
        townOrCity: "Bath",
        postCode: "BA34 9KS",
        mobile: "7753 453243"
    });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SubSection, {
    title: "Apply",
    showHelp: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        _cache[12] || (_cache[12] = _createTextVNode(" We need to collect some more ")),
        _createElementVNode("span", { onDblclick: onInfoDoubleClick }, "information", 32),
        _createTextVNode(". With your permission we will then provide this to Pathlines to open your " + _toDisplayString(_unref(Constants).Product.Name) + " product and transfer any monies in. ", 1)
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("p", { class: "fw-bold" }, " Pathlines cannot provide you with advice or a recommendation. If you want a recommendation you must seek independent financial advice. ", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Dropdown, {
            items: ['Miss', 'Mr', 'Mrs', 'Ms'],
            modelValue: applicationDetail.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((applicationDetail.title) = $event)),
            optional: false,
            description: "Title",
            "abbreviated-description": "Title",
            classes: "form-select form-control"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((applicationDetail.firstName) = $event)),
          type: "text",
          id: "firstName",
          class: "form-control form-control-grouped",
          maxlength: "25",
          autocomplete: "given-name"
        }, null, 512), [
          [_vModelText, applicationDetail.firstName]
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("label", {
          for: "floatingInput",
          class: _normalizeClass({ 'text-primary': false })
        }, "First name", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((applicationDetail.middleNames) = $event)),
          type: "text",
          id: "middleNames",
          class: "form-control form-control-grouped",
          maxlength: "75"
        }, null, 512), [
          [_vModelText, applicationDetail.middleNames]
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("label", {
          for: "floatingInput",
          class: _normalizeClass({ 'text-primary': false })
        }, "Any middle names", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((applicationDetail.lastName) = $event)),
          type: "text",
          id: "lastName",
          class: "form-control form-control-grouped",
          maxlength: "25",
          autocomplete: "family-name"
        }, null, 512), [
          [_vModelText, applicationDetail.lastName]
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("label", {
          for: "floatingInput",
          class: _normalizeClass({ 'text-primary': false })
        }, "Last name", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Dropdown, {
            items: nationalityDropdownData.value,
            modelValue: applicationDetail.nationality,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((applicationDetail.nationality) = $event)),
            optional: false,
            description: "Nationality",
            "abbreviated-description": "Nationality",
            classes: "form-select form-control mt-0 mb-4"
          }, null, 8, ["items", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((applicationDetail.houseNumber) = $event)),
          type: "text",
          class: "form-control",
          maxlength: "25"
        }, null, 512), [
          [_vModelText, applicationDetail.houseNumber]
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("label", {
          for: "floatingInput",
          class: _normalizeClass({ 'text-primary': false })
        }, "House number or name", -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((applicationDetail.street) = $event)),
          type: "text",
          class: "form-control form-control-grouped",
          maxlength: "50"
        }, null, 512), [
          [_vModelText, applicationDetail.street]
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("label", {
          for: "floatingInput",
          class: _normalizeClass({ 'text-primary': false })
        }, "Street", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((applicationDetail.townOrCity) = $event)),
          type: "text",
          id: "city",
          class: "form-control form-control-grouped",
          maxlength: "75",
          autocomplete: "address-level2"
        }, null, 512), [
          [_vModelText, applicationDetail.townOrCity]
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("label", {
          for: "floatingInput",
          class: _normalizeClass({ 'text-primary': false })
        }, "Town/City", -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((applicationDetail.postCode) = $event)),
          type: "text",
          id: "postalCode",
          class: "form-control form-control-grouped",
          maxlength: "10",
          autocomplete: "postal-code"
        }, null, 512), [
          [_vModelText, applicationDetail.postCode]
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("label", {
          for: "floatingInput",
          class: _normalizeClass({ 'text-primary': false })
        }, "Postcode", -1))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(Dropdown, {
            items: countriesDropdownData.value,
            modelValue: applicationDetail.country,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((applicationDetail.country) = $event)),
            optional: false,
            description: "Country",
            "abbreviated-description": "Country",
            classes: "form-select form-control mt-0"
          }, null, 8, ["items", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(Dropdown, {
            items: mobileCountryDropdownData.value,
            modelValue: applicationDetail.mobileCountryCode,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((applicationDetail.mobileCountryCode) = $event)),
            optional: false,
            description: "Mobile country code",
            "abbreviated-description": "Mobile country code",
            classes: "form-select form-control mt-4"
          }, null, 8, ["items", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((applicationDetail.mobile) = $event)),
          type: "text",
          id: "tel",
          class: "form-control mt-1",
          maxlength: "20",
          autocomplete: "tel"
        }, null, 512), [
          [_vModelText, applicationDetail.mobile]
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("label", {
          for: "floatingInput",
          class: _normalizeClass({ 'text-primary': false })
        }, "Mobile", -1))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", null, " When you click the " + _toDisplayString(_unref(Constants).Product.Name) + " button, you are consenting to Guiide passing your pension information to Pathlines Pensions UK Limited. This will direct you into the Pathlines website and application process where you will apply for a Pathlines Pensions UK Limited product. Guiide will share the information you have provided including your income plan and the investment selection modelled with us. ", 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                type: "button",
                onClick: onApplyClicked,
                disabled: __props.isApplying,
                class: "btn px-5 btn-primary"
              }, _toDisplayString(_unref(Constants).Product.Name), 9, _hoisted_22)
            ])
          ])
        ])
      ]),
      _createVNode(DynamicAdviceViewer, { message: __props.adviceMessage }, null, 8, ["message"])
    ]),
    _: 1
  }))
}
}

})